import { z } from 'zod';
/**
 * Reset Identity Sign-In Request Schema
 * POST /api/v2/tenants/:tenantId/users/:userId/reset-sign-in (super-admin)
 * POST /api/v2/org-member/:id/reset-sign-in (home-org system admin)
 *
 * No request body needed - IDs come from URL params
 */ export const ResetIdentitySignInRequestSchema = z.object({});
/**
 * Reset Identity Sign-In Response Schema
 *
 * The person's sign-in account was replaced and the setup link emailed; every
 * session they held is ended. Their membership stays active.
 */ export const ResetIdentitySignInResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=reset-identity-sign-in.schema.js.map